module.exports = __webpack_public_path__ + "img/test_submit.655c9b56.svg";